import React from "react"
import {defineMessages, FormattedMessage, FormattedNumber, injectIntl} from "react-intl"

const messages = defineMessages({
    modal_subtotal_label: {
        id: "proposal.items.quote_subtotal",
        defaultMessage: "Subtotal",
    },
    modal_total_label: {
        id: "proposal.items.quote_total",
        defaultMessage: "Total",
    }
})

type OwnProps = {
    total: string
    currency: string
    subtotal: string
}

const SimpleDisplayTotalsComponent = (props: OwnProps) => {
    return(
        <div className="d-flex justify-content-end">
            <div className="bg-light px-3 py-2 w-25">
                <div className="form-group row mb-1 justify-content-end">
                    <label className="col-6 col-form-label custom-form-label py-1 text-body text-right" htmlFor="subtotal">
                        <FormattedMessage {...messages.modal_subtotal_label}/>
                    </label>
                    <div className="col-6">
                        <div className="input-group mb-0 py-1 justify-content-end">
                            <strong>
                                <FormattedNumber
                                    value={props.subtotal}
                                    currency={props.currency}
                                    style={"currency"}
                                />
                            </strong>
                        </div>
                    </div>
                </div>
                <div className="form-group row mb-1 justify-content-end">
                    <label className="col-6 col-form-label custom-form-label py-1 text-body text-right" htmlFor="total">
                        <FormattedMessage {...messages.modal_total_label}/>
                    </label>
                    <div className="col-6">
                        <div className="input-group mb-0 py-1 justify-content-end">
                            <strong>
                                <FormattedNumber
                                    value={props.total}
                                    currency={props.currency}
                                    style={"currency"}
                                />
                            </strong>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default injectIntl(SimpleDisplayTotalsComponent)


// WEBPACK FOOTER //
// ./src/price-list/components/SimpleDisplayTotalsComponent.tsx